import React from 'react';
import { SITE_CONFIG } from '../config/site';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="privacy-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: January 20, 2026</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to {SITE_CONFIG.name}. We respect your privacy and are committed to protecting your personal data. 
            This privacy policy will inform you about how we look after your personal data when you visit our website 
            and tell you about your privacy rights and how the law protects you.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We may collect, use, store and transfer different kinds of personal data about you:</p>
          <ul>
            <li><strong>Identity Data:</strong> Name, username, or similar identifier</li>
            <li><strong>Contact Data:</strong> Email address, telephone number, and delivery address</li>
            <li><strong>Transaction Data:</strong> Details about payments and orders you have made</li>
            <li><strong>Technical Data:</strong> IP address, browser type, and device information</li>
            <li><strong>Usage Data:</strong> Information about how you use our website and services</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use your personal data for the following purposes:</p>
          <ul>
            <li>To process and deliver your orders</li>
            <li>To manage your account and provide customer support</li>
            <li>To send you order confirmations and updates</li>
            <li>To improve our website and services</li>
            <li>To comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Security</h2>
          <p>
            We have implemented appropriate security measures to prevent your personal data from being accidentally lost, 
            used, or accessed in an unauthorized way. We use Firebase Authentication and Firestore for secure data storage 
            and management.
          </p>
        </section>

        <section>
          <h2>5. Data Retention</h2>
          <p>
            We will only retain your personal data for as long as necessary to fulfill the purposes we collected it for, 
            including for the purposes of satisfying any legal, accounting, or reporting requirements.
          </p>
        </section>

        <section>
          <h2>6. Your Rights</h2>
          <p>Under data protection laws, you have rights including:</p>
          <ul>
            <li><strong>Right to Access:</strong> Request access to your personal data</li>
            <li><strong>Right to Correction:</strong> Request correction of inaccurate personal data</li>
            <li><strong>Right to Erasure:</strong> Request deletion of your personal data</li>
            <li><strong>Right to Object:</strong> Object to processing of your personal data</li>
            <li><strong>Right to Data Portability:</strong> Request transfer of your personal data</li>
          </ul>
          <p>
            You can exercise your right to delete your account at any time through your profile settings.
          </p>
        </section>

        <section>
          <h2>7. Third-Party Services</h2>
          <p>
            We use third-party services to help us operate our business:
          </p>
          <ul>
            <li><strong>Firebase:</strong> For authentication and database services</li>
            <li><strong>Google Sign-In:</strong> For authentication purposes</li>
            <li><strong>Payment Processors:</strong> For processing payments securely</li>
          </ul>
          <p>
            These third parties have access to your personal data only to perform specific tasks on our behalf 
            and are obligated not to disclose or use it for any other purpose.
          </p>
        </section>

        <section>
          <h2>8. Cookies</h2>
          <p>
            Our website uses cookies to distinguish you from other users. This helps us provide you with a good 
            experience when you browse our website and allows us to improve our site.
          </p>
        </section>

        <section>
          <h2>9. Changes to This Privacy Policy</h2>
          <p>
            We may update our privacy policy from time to time. We will notify you of any changes by posting the 
            new privacy policy on this page and updating the "Last Updated" date.
          </p>
        </section>

        <div className="copyright-notice">
          <p>
            <strong>&copy; {new Date().getFullYear()} {SITE_CONFIG.name}. All rights reserved.</strong>
          </p>
          <p>
            All content, trademarks, and data on this website are the property of {SITE_CONFIG.name} 
            and are protected by applicable copyright and trademark laws.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
